/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { authManager } from 'services/auth';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	TGetNewMessageCountResponsePayload,
	TMessagesResponsePayload,
	TOrganizationsResponsePayload,
	TUserInfoResponsePayload,
	TUsersListResponsePayload,
	TSaveSessionDataRequestPayload,
	TSaveSessionDataResponsePayload,
} from './types';
import {
	getMessagesRequest,
	getMessagesSuccess,
	getNewMessageCountRequest,
	getNewMessageCountSuccess,
	getOrganizationsRequest,
	getOrganizationsSuccess,
	getUserInfoRequest,
	getUserInfoSuccess,
	getUsersListRequest,
	getUsersListSuccess,
	getSaveSessionDataRequest,
	getSaveSessionDataSuccess,
} from './reducer';

function* getOrganizationsWorker() {
	try {
		const response: TOrganizationsResponsePayload = yield call(api.user.getOrganizations);
		yield put(getOrganizationsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getUserInfoRequestWorker() {
	try {
		const response: TUserInfoResponsePayload = yield call(api.user.getUserInfo);
		yield put(getUserInfoSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	} finally {
		// yield put(hideLoading());
	}
}

function* getNewMessageCountRequestWorker() {
	try {
		const response: TGetNewMessageCountResponsePayload = yield call(api.user.getNewMessageCount);
		yield put(getNewMessageCountSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	} finally {
		// yield put(hideLoading());
	}
}

function* getMessagesRequestWorker() {
	try {
		const response: TMessagesResponsePayload = yield call(api.user.getMessages);
		yield put(getMessagesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	} finally {
		// yield put(hideLoading());
	}
}

function* getUsersListRequestWorker() {
	try {
		const response: TUsersListResponsePayload = yield call(api.user.getUsersList);
		yield put(getUsersListSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	} finally {
		// yield put(hideLoading());
	}
}

export function* saveSessionDataRequestWorker(
	action: PayloadAction<TSaveSessionDataRequestPayload>,
) {
	const { payload } = action;

	try {
		const response: TSaveSessionDataResponsePayload = yield call(api.user.saveSessionData, payload);
		yield put(getSaveSessionDataSuccess(response));
		void authManager.loginRedirect();
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	} finally {
		// yield put(hideLoading());
	}
}

export function* userSaga() {
	yield takeEvery(getOrganizationsRequest.type, getOrganizationsWorker);
	yield takeEvery(getUserInfoRequest.type, getUserInfoRequestWorker);
	yield takeEvery(getNewMessageCountRequest.type, getNewMessageCountRequestWorker);
	yield takeEvery(getMessagesRequest.type, getMessagesRequestWorker);
	yield takeEvery(getUsersListRequest.type, getUsersListRequestWorker);
	yield takeEvery(getSaveSessionDataRequest.type, saveSessionDataRequestWorker);
}
